import React from 'react';
import { RichText } from '@thd-olt-component-react/rich-text';
import classNames from 'classnames';
import { string, bool, shape } from 'prop-types';

export const RichTextWrapper = ({
  richTextObj,
  componentId,
  isLivePreview
}) => {

  const { textWidthClasses, textPaddingClasses, richText, imageFirst } = richTextObj;
  const richTextClasses = classNames(`${textWidthClasses} ${textPaddingClasses}`, {
    'sui-order-1': !imageFirst,
    'sui-order-2': imageFirst,
  });

  return (
    <div
      data-testid="text-padding-test"
      className={richTextClasses}
      data-contentful-entry-id={componentId}
      data-contentful-field-id="description"
    >
      <RichText content={richText} isLivePreview={isLivePreview} />
    </div>
  );
};

RichTextWrapper.propTypes = {
  componentId: string.isRequired,
  isLivePreview: bool.isRequired,
  richTextObj: shape({}).isRequired
};
